<template>
    <div class="tsa-conditionDateV2" :class="[dateValue && dateValue.length > 0 ? 'active' : '', type ]" @click.stop="aaa">
        <p class="label" v-if="label">{{ label }}</p>
        <el-date-picker
            ref="tsa-conditionDateV2-date"
            popper-class="tsa-conditionDateV2-downMenu"
            class="tsa-date-picker-v2"
            prefix-icon=""
            v-model="dateValue"
            :disabled="disabled"
            :value-format="valueFormat"
            :type="type"
            range-separator="-"
            :placeholder="placeholder"
            :start-placeholder="startPlaceholder"
            :end-placeholder="endPlaceholder"
            :default-time="type === 'date' ? null :  ['00:00:00', '23:59:59']"
            @change="change"
            :picker-options="pickerOptions"
        >
        </el-date-picker>
        <span v-if="(type === 'date' && value) || (value && value.length > 0)" class="icon el-icon-circle-close" @click.stop="close"></span>
        <span v-else class="icon el-icon-date" @click.stop="pickerFocus"></span>
    </div>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'datetimerange' // daterange, datetimerange date
        },
        value: {
            type: Array | null,
            default: () => []
        },
        label: {
            type: String,
            default: ''
        },
        startPlaceholder: {
            type: String,
            default: '开始时间'
        },
        endPlaceholder: {
            type: String,
            default: '结束时间'
        },
        placeholder: {
            type: String,
            default: '选择日期'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        valueFormat: {
            type: String,
            default: 'timestamp'
        },
        pickerOptions: {
            type: Object,
            default: () => ({})
        }
    },
    data () {
        return {
            dateValue: [],
        }
    },
    watch: {
        value: {
            handler (val) {
                if (this.type === 'date') {
                    this.dateValue = val
                } else {
                    this.dateValue = val
                }
                
            },
            immediate: true
        }
    },
    methods: {
        aaa () {},
        change (val) {
            if (this.type === 'date') {
                this.$emit('input', val || null)
                this.$emit('on-change', val || null)
            } else {
                this.$emit('input', val || [])
                this.$emit('on-change', val || [])
            }
            
        },
        close () {
            if (this.type === 'date') {
                this.$emit('input', null)
                this.$emit('on-change', null)
            } else {
                this.$emit('input', [])
                this.$emit('on-change', [])
            }
            
        },
        pickerFocus () {
            if (this.focusStatus) return
            this.$refs['tsa-conditionDateV2-date'].focus()
        }
    },
}
</script>

<style lang="scss" scoped>
    .tsa-conditionDateV2 {
        display: flex;
        align-items: center;
        position: relative;
        width: max-content;
         &.date {
            :deep(.el-date-editor) {
                &.tsa-date-picker-v2 {
                    width: 250px;
                    .el-input__inner {
                        border-radius: 6px;
                        height: 32px;
                        line-height: 32px;
                        border: 1px solid #D4D6D9;
                        padding: 3px 10px;
                        &:focus {
                            border-color: #2468F2;
                        }
                    }
                    .el-input__prefix {
                        display: none;
                    }
                    .el-input__suffix {
                        display: none;
                    }
                }
            }
        }
        &.daterange {
            :deep(.el-date-editor) {
                &.tsa-date-picker-v2 {
                    width: 250px;
                }
            }
        }
        &.active {
            &:hover {
                .el-icon-circle-close {
                    display: block;
                }
                .el-icon-date {
                    display: none;
                }
            }
        }
        .label {
            flex-shrink: 0;
            font-size: 14px;
            color: #5C5F66;
        }
        :deep(.el-date-editor) {
            &.tsa-date-picker-v2 {
                width: 360px;
                &.el-input__inner {
                    border-radius: 6px;
                    height: 32px;
                    line-height: 32px;
                    border: 1px solid #D4D6D9;
                    &.is-active {
                        border-color: #2468F2;
                    }
                    .el-input__icon {
                        display: none;
                    }
                    .el-range-separator {
                        line-height: 23px;
                        font-size: 14px;
                        color: #B8BABF;
                    }
                    .el-range-input {
                        width: 44%;
                        color: #151B26;
                        font-size: 14px;
                    }
                }
            }
        }
        .icon {
            position: absolute;
            right: 12px;
            top: 50%;
            transform: translateY(-50%);
            color: #999A9F;
            font-size: 14px;
            cursor: pointer;
            &.el-icon-circle-close {
                color: #999A9F;
                cursor: pointer;
            }
        }
    }
</style>